import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgeModeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5h14v14H5z",
			opacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5v14M19 5v14M5 19h14",
			opacity: .15
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 3,
			d: "M5 5h14"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 5,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgEdgeModeIcon;
